/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  TempleService,
  CommonService,
  PujaService,
  UserReviewService,
  PujaPackageService,
} from "td_server/services";
import {
  setLoading,
  setSelectedTempleDetailsForPuja,
  setPromotionalList,
  setSelectedPromotionalPujaOrganisations,
  setPujaCategoryList,
  setPujaMergedSubCategoryList,
} from "./../slices/pujaSlice";
import { trackedAsync } from "../../utils/analyics/trackedAsync";
export const getTempleDetailsById =
  (templeId: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await trackedAsync(()=>TempleService.getOrganisationDetailsById(templeId));
      dispatch(setSelectedTempleDetailsForPuja(response));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getPromotionalPujaList =
  () => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await trackedAsync(()=>TempleService.getPromotionalPujaDashBoardListActive());
      dispatch(setPromotionalList(response?.promotionalList));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };
// get both special promotional puja and chadhava active
export const getPromotionalPujaChadhavaDashBoardListActive =
  () => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await trackedAsync(()=>TempleService.getPromotionalPujaChadhavaDashBoardListActive());
      dispatch(setPromotionalList(response?.promotionalList));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getPromotionalPujaChadhavaDashBoardListActiveWithPriceConversion =
  (isOverseas: boolean = false, platformFeeForChadhava: number = 0, rate = 1) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await trackedAsync(()=>TempleService.getPromotionalChadhavaDashBoardListActiveWithPriceConversion(
          isOverseas,
          platformFeeForChadhava,
          rate,
        ));
      if (response?.promotionalList) {
        dispatch(setPromotionalList(response?.promotionalList));
      }

      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getSpecialPujaList =
  () => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await trackedAsync(()=>TempleService.getPromotionalPujaDashBoardListActiveInactive());
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getPromotionalPujaListById =
  (id: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>TempleService.getPromotionalPujaListById(id));

      dispatch(setSelectedPromotionalPujaOrganisations(response?.organisation));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
    }
  };

export const getPromotionalPujaListByNameKey =
  (nameKey: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await trackedAsync(()=>TempleService.getPromotionalPujaListByNameKey(nameKey));
      dispatch(setSelectedPromotionalPujaOrganisations(response?.organisation));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      console.log("Error : ", e);
      dispatch(setLoading(false));
    }
  };

export const getTemplePujaCategoryList =
  () => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>CommonService.getTemplePujaCategoryList());
      dispatch(setPujaCategoryList(response?.categoryList));
      dispatch(setPujaMergedSubCategoryList(response?.mergedSubCategory));

      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const addPromotionalPujaAction =
  (data: any) => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>TempleService.addPromotionalPujaFromWeb(data));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const deletePromotionalPujaAction =
  (templePuja: any, specialPujaId: any) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await TempleService.deletePromotionalPuja(
        templePuja,
        specialPujaId,
      );
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getPriceInfoOfPujaAndPackageV1 =
  (
    item: any,
    templeId: string,
    packageId: string,
    isOverseas: boolean = false,
    isPrasad: boolean = false,
  ) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>PujaService.getPujaPriceInfo(
        item,
        templeId,
        packageId,
        isOverseas,
        isPrasad,
      ));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getTopFivePujaFeedBack =
  (orderType: string, templeId: string) =>
  async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>UserReviewService.getTopFiveFeedback(
        orderType,
        templeId,
      ));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("");
    }
  };

export const getAllPujaFromPujaCollection =
  () => async (dispatch: any, getState: any) => {
    try {
      dispatch(setLoading(true));
      const response = await trackedAsync(()=>PujaService.getAllPujaFromPujaCollection());
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      dispatch(setLoading(false));
      return Promise.reject("Failed to fetch puja list");
    }
  };

export const updatePujaByNameKey =
  (orgId: string, pujaNameKey: string, field: string, value: any) =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const response = await PujaService.updatePujaByNameKey(
        orgId,
        pujaNameKey,
        field,
        value,
      );
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (error) {
      dispatch(setLoading(false));
      return Promise.reject("Failed to update Puja");
    }
  };

export const updateTemplePujaCollection = () => async (dispatch: any) => {
  try {
    dispatch(setLoading(true));
    const response = await TempleService.updateTemplePujaCollection();
    dispatch(setLoading(false));
    return Promise.resolve(response);
  } catch (error) {
    dispatch(setLoading(false));
    return Promise.reject("Failed to update Puja collection");
  }
};

export const getPaginatedActivePujas =
  (lastDoc: any = null, pageSize: number = 10) =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const response = await trackedAsync(() =>
        PujaService.getPaginatedActivePujas(lastDoc, pageSize),
      );
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (error) {
      dispatch(setLoading(false));
      return Promise.reject("Failed to fetch Puja");
    }
  };

export const getPujaPackageDetailsAction =
  (pujaNameKey: string) => async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const response: any =
        await trackedAsync(()=>PujaPackageService.getPujaPackageDetails(pujaNameKey));
      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      console.error("Error fetching puja package details:", e);
      dispatch(setLoading(false));
      return Promise.reject("Failed to fetch puja package details");
    }
  };

export const getPujaPackagePriceAction =
  (
    _priceBreakupV1: any,
    isOverSeas: boolean = false,
    rate: number = 1,
    isPrasad: boolean = false,
  ) =>
  async (dispatch: any) => {
    try {
      dispatch(setLoading(true));
      const response: any = await trackedAsync(()=>PujaPackageService.getPujaPackagePrice(
        _priceBreakupV1,
        isOverSeas,
        rate,
        isPrasad,
      ));

      dispatch(setLoading(false));
      return Promise.resolve(response);
    } catch (e) {
      console.error("Error fetching puja package price:", e);
      dispatch(setLoading(false));
      return Promise.reject("Failed to fetch puja package price");
    }
  };
